const fr = {
  seo: {
    home: {
      title: "Wild Spoon — Chef privé à Grenade | Dîners privés dans l'Albaicín",
      description: "Wild Spoon, expériences gastronomiques privées d'Edu Vincent, cuisinier autodidacte franco-catalan dans l'Albaicín de Grenade : dîners privés dans l'Albaicín ou chef privé à domicile. Groupes à partir de 4 personnes.",
    },
    reservas: {
      title: "Réservez votre expérience — Wild Spoon | Chef privé Grenade",
      description: "Demandez votre dîner privé avec Wild Spoon : chez Edu, dans l'Albaicín de Grenade, ou avec un chef privé à domicile. Edu confirme personnellement la disponibilité.",
    },
    legal: {
      title: "Mentions légales — Wild Spoon",
      description: "Mentions légales, confidentialité et cookies de Wild Spoon, expériences gastronomiques privées d'Edu Vincent à Grenade.",
    },
    notFound: {
      title: "Page introuvable — Wild Spoon",
      description: "La page que vous cherchez n'existe pas ou a été déplacée.",
    },
  },
  nav: {
    experiencias: "Expériences",
    cocina: "La cuisine",
    edouard: "Edu",
    galeria: "Galerie",
    opiniones: "Avis",
    contacto: "Contact",
    reservar: "Réserver",
  },
  hero: {
    overline: "Wild Spoon",
    titleA: "Une cuisine de caractère.",
    titleB: "Une table dans l'Albaicín.",
    subtitle: "Des expériences gastronomiques privées créées par Edu Vincent au cœur de l'Albaicín, ou directement chez vous.",
    ctaPrimary: "Réserver une expérience",
    ctaSecondary: "Découvrir Wild Spoon",
    note: "À partir de 4 personnes · Grenade",
    scroll: "Défiler",
    imageAlt: "Edu Vincent dans sa maison de l'Albaicín (photo réelle)",
  },
  marquee: {
    words: ["feu", "instinct", "générosité", "créativité", "partage"],
  },
  intro: {
    overline: "Le concept",
    title: "Bien manger, ouvrir une bouteille et s'installer à table, sans rien presser.",
    p1: "Wild Spoon est née d'une idée simple : bien manger, ouvrir une bouteille et s'installer autour d'une table, sans aucune hâte.",
    p2: "Edu Vincent crée des expériences gastronomiques privées à Grenade, pour petits groupes, aussi bien dans sa propre maison qu'en se déplaçant chez vous.",
    meta: "Cuisine privée · Albaicín, Grenade · Groupes dès 4 personnes",
  },
  menus: {
    overline: "Menus",
    title: "Trois façons de s'installer à table.",
    perPerson: "par personne",
    note: "Un menu pensé pour chaque table et chaque occasion. Réservations à partir de 4 personnes.",
    rows: [
      { n: "5", label: "temps", price: "75" },
      { n: "6", label: "temps", price: "90" },
      { n: "7", label: "temps", price: "100" },
    ],
  },
  twoWays: {
    overline: "Deux façons de vivre Wild Spoon",
    title: "Une même table, deux décors.",
    block1: {
      tag: "Chez Edu",
      title: "Une table dans l'Albaicín",
      text: "Au cœur de Grenade, Edu ouvre les portes de sa maison pour accueillir de petits groupes autour de sa table. Cuisine, conversations et sobremesa dans une maison qui a tout le caractère de l'Albaicín.",
      location: "Albaicín · Grenade",
      note: "L'adresse exacte est communiquée une fois la réservation confirmée.",
      cta: "Réserver une expérience",
      imageAlt: "La pastilla d'agneau à la patate douce de Wild Spoon, servie chez Edu (photo réelle)",
    },
    block2: {
      tag: "Wild Spoon chez vous",
      title: "Edu cuisine. Vous profitez.",
      text: "Wild Spoon peut aussi se déplacer à votre maison, villa, appartement ou hébergement à Grenade et ses environs. Edu s'occupe de la cuisine pour que vous ne vous occupiez que de profiter de la table.",
      forWhom: "Idéal pour :",
      list: ["Vacances à Grenade", "Retrouvailles entre amis", "Célébrations en famille", "Villas et maisons de campagne", "Occasions spéciales", "Petits groupes privés"],
      cta: "Consulter les disponibilités",
      imageAlt: "Une cuisine de caractère : un dressage de Wild Spoon (photo réelle)",
    },
  },
  cocina: {
    overline: "La cuisine",
    title: "Sans frontières. Sans règles inutiles.",
    lead: "Une cuisine libre, personnelle et sans frontières : entre la France et l'Espagne, avec la mémoire de la cuisine d'une grand-mère galicienne et le regard tourné vers chaque table.",
    chapters: [
      { n: "01", t: "Feu", d: "Braises, cuissons lentes et saveurs intenses." },
      { n: "02", t: "Instinct", d: "La recette est un point de départ, pas une limite." },
      { n: "03", t: "Produit", d: "Chaque ingrédient a quelque chose à dire." },
      { n: "04", t: "Générosité", d: "Des assiettes soignées, mais jamais timides." },
      { n: "05", t: "Mémoire", d: "La France, l'Espagne, la Galice, les voyages, les recettes familiales." },
      { n: "06", t: "Curiosité", d: "Prendre du connu et l'emmener ailleurs." },
    ],
    mainImageAlt: "Cuisson lente au feu dans la cuisine d'Edu (photo réelle)",
    wideImageAlt: "Le riz au veau dans la paella, pour le centre de la table (photo réelle)",
    sign: "Wild Spoon — Du feu. Du caractère. De la générosité.",
  },
  edouard: {
    overline: "Edu",
    name: "Edu Vincent",
    subtitle: "Cuisinier autodidacte. Franco-catalan. Sauvage par nature.",
    bio: [
      "Franco-catalan et cuisinier autodidacte, j'ai construit ma cuisine entre deux cultures, nourri par les traditions françaises et espagnoles et par les souvenirs de la cuisine de ma grand-mère gallega.",
      "Ma cuisine est instinctive, généreuse et résolument sauvage.",
      "J'aime le feu, les braises, les cuissons lentes, les sauces profondes, l'acidité, le croquant et les goûts francs. Je cherche des assiettes belles et soignées, mais jamais timides : chez moi, la générosité fait partie de l'élégance.",
      "J'aime surtout prendre une recette que l'on croit connaître, respecter son âme, puis la pousser beaucoup plus loin. Retravailler les textures, intensifier les saveurs, ajouter un détail inattendu… jusqu'à transformer un plat familier en véritable expérience.",
      "Je cuisine sans frontières et sans règles inutiles. Avec de l'instinct, du feu, de la créativité et une obsession : que chaque bouchée ait quelque chose à raconter.",
      "Parce que pour moi, la cuisine reste avant tout un moment de partage, de plaisir et de convivialité.",
    ],
    sign: "Wild Spoon — du feu, du caractère, de la générosité.",
    photoCaption: "Edu Vincent sur la terrasse de sa maison de l'Albaicín — photo réelle",
    imageAlt: "Edu Vincent sur sa terrasse, en veste noire (photo réelle)",
  },
  testimonios: {
    overline: "Avis",
    title: "Ils vous le racontent, ceux qui se sont assis à la table.",
    lead: "Des avis authentiques de voyageurs qui ont vécu l'expérience avec Edu, publiés sur Sazón The Folk Cook, la plateforme où il propose également ses expériences.",
    emptyTitle: "Les avis arriveront très bientôt dans cet espace.",
    emptyText: "Nous préparons une sélection des vrais avis de ceux qui ont déjà vécu l'expérience.",
  },
  granada: {
    overline: "Grenade",
    title: "Grenade s'invite à table.",
    text: "Wild Spoon est née dans l'Albaicín, au cœur de Grenade. Une ville de cultures mêlées, de longues sobremesas et de saveurs qui voyagent depuis des siècles d'un côté à l'autre.",
    meta: "Albaicín · Grenade · Espagne",
  },
  sazon: {
    overline: "Réputation",
    title: "Des années à cuisiner pour des voyageurs du monde entier.",
    text: "Edu propose également des expériences gastronomiques via Sazón The Folk Cook.",
    cta: "Voir le profil sur Sazón",
  },
  galeria: {
    overline: "Galerie",
    title: "Instantanés de Wild Spoon.",
    filters: { todas: "Tout", platos: "Plats", postres: "Desserts", cocina: "La cuisine", edouard: "Edu" },
  },
  ctaBand: {
    title: "Prêts à vous mettre à table ?",
    text: "Dites-nous la date et le nombre de convives. Edu vérifiera personnellement la disponibilité et vous confirmera.",
    cta: "Réserver votre expérience",
  },
  reservas: {
    overline: "Réservations",
    title: "Réservez votre expérience",
    lead: "Dites-nous la date, le nombre de convives et l'expérience souhaitée. Edu vérifiera personnellement la disponibilité. Menus en 5, 6 ou 7 temps, dès 75 € par personne.",
    notice: "Votre demande ne sera confirmée qu'après avoir reçu la confirmation personnelle d'Edu.",
    stepsTitle: "Comment ça marche",
    steps: [
      { t: "Vous envoyez la demande", d: "Indiquez-nous la date, le nombre de personnes et le type d'expérience." },
      { t: "Edu l'examine", d: "Il vérifie personnellement la disponibilité et vous contacte." },
      { t: "Votre table est confirmée", d: "Ce n'est qu'une fois Edu confirmé que votre réservation est acquise." },
    ],
    form: {
      nombre: "Prénom",
      nombrePh: "Votre prénom",
      apellidos: "Nom",
      apellidosPh: "Votre nom",
      email: "Email",
      emailPh: "vous@email.com",
      telefono: "Téléphone / WhatsApp",
      telefonoPh: "+34 600 000 000",
      fecha: "Date souhaitée",
      personas: "Nombre de convives",
      personasMin: "Wild Spoon est disponible pour les groupes à partir de 4 personnes.",
      tipo: "Type d'expérience",
      tipoEdouard: "Chez Edu — Albaicín",
      tipoEdouardHint: "Dîner privé à sa table, dans l'Albaicín",
      tipoDomicilio: "Chef privé à domicile",
      tipoDomicilioHint: "Edu cuisine là où vous séjournez",
      direccion: "Adresse ou zone où se déroulera l'expérience",
      direccionPh: "Nom de l'hébergement, rue, quartier…",
      idioma: "Langue préférée",
      idiomas: ["Español", "English", "Français", "Autre"],
      alergias: "Allergies, intolérances ou régimes particuliers",
      alergiasPh: "Parlez-nous des besoins alimentaires du groupe",
      mensaje: "Message / occasion spéciale",
      mensajePh: "Une célébration, un anniversaire, tout simplement un bon dîner…",
      acepto: "J'ai lu et je comprends que cette demande est soumise à la disponibilité et que la réservation ne sera confirmée qu'après réception de la confirmation de Wild Spoon.",
      submit: "Demander les disponibilités",
      required: "Champ obligatoire",
      invalidEmail: "Veuillez saisir un email valide",
      aceptoRequired: "Vous devez accepter la condition de confirmation pour envoyer la demande.",
      direccionRequired: "Veuillez indiquer l'adresse ou la zone où se déroulera l'expérience.",
      fechaRequired: "Veuillez choisir une date future.",
      submitting: "Envoi en cours…",
      error: "La demande n'a pas pu être envoyée. Réessayez ou écrivez-nous via le formulaire de contact.",
    },
    success: {
      title: "Demande reçue",
      p1: "Merci d'avoir contacté Wild Spoon.",
      p2: "Edu vérifiera personnellement la disponibilité pour la date demandée et vous contactera.",
      p3: "N'oubliez pas : la réservation n'est pas encore confirmée.",
      cta: "Retour à l'accueil",
    },
  },
  contacto: {
    overline: "Contact",
    title: "Parlons de votre table.",
    lead: "Pour toute question sur les expériences, écrivez-nous et nous vous répondrons personnellement.",
    location: "Grenade et environs",
    form: {
      nombre: "Nom",
      email: "Email",
      telefono: "Téléphone",
      mensaje: "Message",
      submit: "Envoyer le message",
      submitting: "Envoi en cours…",
      success: "Message envoyé. Merci de votre message, nous vous répondrons personnellement.",
      error: "Le message n'a pas pu être envoyé. Veuillez réessayer.",
      required: "Champ obligatoire",
    },
    whatsapp: "Écrivez-nous sur WhatsApp",
  },
  footer: {
    brandPhrase: "Du feu. Du caractère. De la générosité.",
    tagline: "Cuisine privée à Grenade. Des expériences gastronomiques autour d'une table.",
    navTitle: "Découvrir",
    nav: { experiencias: "Expériences", reservas: "Réservations", contacto: "Contact" },
    legalTitle: "Légal",
    legal: { aviso: "Mentions légales", privacidad: "Confidentialité", cookies: "Cookies" },
    lang: "Langue",
    rights: "Tous droits réservés.",
  },
  legal: {
    aviso: {
      title: "Mentions légales",
      blocks: [
        { h: "Éditeur du site web", p: [
          "Éditeur / Responsable : Edouard Vincent.",
          "Nom commercial : Wild Spoon.",
          "NIE : Y4953298D.",
          "Adresse : Calle Carnero 4, 2B, 18010 Grenade, Espagne.",
          "E-mail de contact et de réservations : evincent.molas@gmail.com.",
          "Site web : https://wild-spoon.com",
        ] },
        { h: "Objet", p: [
          "Edouard Vincent exploite le site web https://wild-spoon.com sous le nom commercial Wild Spoon afin d'offrir des expériences gastronomiques privées à Grenade et ses environs, aussi bien dans son propre domicile qu'au domicile du client, ainsi que des services de cuisinier privé pour groupes à partir de 4 personnes.",
        ] },
        { h: "Conditions d'utilisation", p: [
          "L'accès et la navigation sur le site web impliquent l'acceptation des présentes conditions. L'utilisateur s'engage à faire un usage approprié des contenus et à ne pas les employer à des fins illicites.",
          "Les demandes de réservation envoyées via le formulaire ne constituent pas une réservation confirmée : elles restent soumises à la disponibilité et ne sont confirmées que lorsque Edu communique personnellement sa confirmation au client.",
        ] },
        { h: "Propriété intellectuelle et industrielle", p: [
          "Tous les contenus du site (textes, photographies, vidéos, logos et design) sont la propriété d'Edouard Vincent ou de tiers ayant autorisé leur utilisation, et sont protégés par la réglementation sur la propriété intellectuelle et industrielle. Leur reproduction, distribution ou transformation sans autorisation est interdite.",
        ] },
        { h: "Responsabilité", p: [
          "L'éditeur ne saurait être tenu responsable des décisions prises à partir des contenus publiés sur le site, ni des dommages pouvant découler d'interférences, d'omissions ou d'interruptions indépendantes de sa volonté.",
          "Ce site peut contenir des liens vers des sites web de tiers (par exemple, des plateformes où les expériences sont également proposées) dont il ne contrôle pas les contenus.",
        ] },
        { h: "Droit applicable et juridiction", p: [
          "La relation entre l'éditeur et l'utilisateur est régie par le droit espagnol. En cas de litige, les parties se soumettent aux tribunaux du domicile du consommateur, conformément à la réglementation applicable.",
        ] },
      ],
    },
    privacidad: {
      title: "Politique de confidentialité",
      blocks: [
        { h: "Responsable du traitement", p: [
          "Responsable : Edouard Vincent (nom commercial : Wild Spoon).",
          "NIE : Y4953298D.",
          "Adresse : Calle Carnero 4, 2B, 18010 Grenade, Espagne.",
          "E-mail : evincent.molas@gmail.com.",
        ] },
        { h: "Données traitées", p: [
          "Via le formulaire de réservation : nom et prénom, e-mail, téléphone / WhatsApp, date souhaitée, nombre de convives, type d'expérience, adresse ou zone (si la prestation a lieu chez vous), langue préférée, allergies, intolérances ou régimes particuliers et, le cas échéant, votre message ou l'occasion spéciale.",
          "Via le formulaire de contact : nom, e-mail, téléphone (facultatif) et message.",
        ] },
        { h: "Finalités du traitement", p: [
          "Gérer les demandes de réservation.",
          "Contacter le client.",
          "Organiser la prestation du service.",
          "Répondre aux demandes envoyées via le formulaire de contact.",
          "Respecter les obligations légales applicables.",
        ] },
        { h: "Base juridique", p: [
          "L'exécution d'un contrat ou de mesures précontractuelles (art. 6.1.b du RGPD) pour la gestion des demandes de réservation et des questions.",
          "Le consentement (art. 6.1.a du RGPD) pour le traitement des allergies, intolérances ou régimes particuliers, s'agissant de données relatives à la santé, ainsi que pour l'utilisation de cookies non strictement nécessaires.",
        ] },
        { h: "Communications internes et sous-traitants", p: [
          "Chaque demande ou message reçu peut générer une notification interne envoyée à evincent.molas@gmail.com.",
          "L'envoi d'e-mails est réalisé via Resend, prestataire technique de services d'envoi d'e-mails agissant en qualité de sous-traitant. Le recours à ce prestataire peut impliquer des transferts internationaux de données, couverts par les garanties prévues par le RGPD (clauses contractuelles types ou autres garanties appropriées).",
          "Aucune donnée n'est communiquée à des tiers à des fins de marketing. Aucune communication commerciale n'est envoyée sans consentement explicite et distinct.",
        ] },
        { h: "Conservation des données", p: [
          "Les données sont conservées pendant le temps nécessaire pour traiter la demande ou la question et, le cas échéant, la prestation du service, ainsi que pendant les délais exigés par la réglementation applicable.",
        ] },
        { h: "Droits", p: [
          "Vous pouvez exercer vos droits d'accès, de rectification, d'effacement, d'opposition, de limitation du traitement et de portabilité en écrivant à evincent.molas@gmail.com.",
          "Vous pouvez également introduire une réclamation auprès de l'Agence espagnole de protection des données (www.aepd.es) si vous estimez que l'exercice de vos droits n'a pas été correctement traité.",
        ] },
        { h: "Sécurité et mise à jour de la politique", p: [
          "Des mesures techniques et organisationnelles appropriées sont appliquées pour protéger les données personnelles. Cette politique peut être mise à jour ; la version en vigueur est toujours publiée sur cette page.",
        ] },
      ],
    },
    cookies: {
      title: "Politique de cookies",
      blocks: [
        { h: "Qu'est-ce qu'un cookie ?", p: [
          "Les cookies et technologies similaires (comme le stockage local) sont de petits fichiers enregistrés sur votre appareil qui permettent de conserver et de récupérer des informations sur votre navigation.",
        ] },
        { h: "Cookies strictement nécessaires", p: [
          "Ce site utilise uniquement un stockage strictement nécessaire à son fonctionnement : la préférence de langue sélectionnée et l'état de votre consentement. Ces éléments ne requièrent pas de consentement.",
        ] },
        { h: "Cookies analytiques", p: [
          "Si vous donnez votre consentement, le site charge un outil statistique tiers (PostHog) qui enregistre de manière anonyme l'interaction avec les pages afin d'améliorer l'expérience. Ce chargement n'intervient qu'après acceptation et peut être retiré à tout moment.",
        ] },
        { h: "Comment gérer ou retirer le consentement", p: [
          "Vous pouvez accepter, refuser ou configurer les cookies depuis l'avis de consentement et, à tout moment, depuis le lien « Configurer les cookies » disponible dans le pied de page. Le retrait du consentement est aussi simple que son octroi.",
        ] },
      ],
    },
  },
  cookiesUI: {
    title: "Votre vie privée",
    text: "Ce site utilise des cookies strictement nécessaires à son fonctionnement (langue et cette préférence) et, uniquement avec votre consentement, un outil d'analyse anonyme pour l'améliorer.",
    accept: "Accepter",
    reject: "Refuser",
    config: "Configurer",
    save: "Enregistrer les préférences",
    necessary: "Strictement nécessaires",
    necessaryDesc: "Langue sélectionnée et votre consentement. Toujours actifs.",
    analytics: "Analyse anonyme",
    analyticsDesc: "Statistiques d'utilisation anonymes (PostHog) pour améliorer le site. Chargées uniquement si vous les acceptez.",
    footerLink: "Configurer les cookies",
  },
  common: {
    notFoundTitle: "Page introuvable",
    notFoundText: "La page que vous cherchez n'existe pas ou a été déplacée.",
    backHome: "Retour à l'accueil",
  },
};

export default fr;
